import React from "react";
import { SectionArticle } from "../../shared/ArticleTemplate";

const Heritage = ({parentPath}) =>
  <SectionArticle sectionName="heritage" backRoute={parentPath}/>

export default Heritage;